import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id BEF1218E-7AF7-45F9-930E-915791D51EDC
 * name floor-lamp
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/floor-lamp.svg
 * tags
 * - Home Automation 
 */
export const FloorLampIcon = createSvgIcon(<><path d="M15,2L17,9H7L9,2M11,10H13V20H16V22H8V20H11V10Z" /></>, 'FloorLampIcon');
export default FloorLampIcon